import React from 'react'
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import themes from '../../../modules/theming/themes'
import { resolveThemeName } from '../../../modules/theming/resolveThemeName'
import UISelectors from '../../../redux/selectors/UI'

const ThemeProvider = ({ children }) => {
  const selectedThemeName = useSelector(UISelectors.selectedThemeName)
  const theme = themes[resolveThemeName(selectedThemeName)]

  return (
    <MUIThemeProvider theme={theme}>
      {children}
    </MUIThemeProvider>
  )
}

export default ThemeProvider
